import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import React from "react";

export const SpinnerLoadGenLC = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card sx={{ width: "40%" }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              padding: "10px 0",
            }}
          >
            <CircularProgress
              aria-label="Cargando..."
              sx={{ color: "var(--main-color-vino)" }}
            />
            <Typography
              variant="body1"
              sx={{
                fontWeight: "500",
                color: "text.secondary",
                textAlign: "center",
              }}
            >
              Generando línea de captura...
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
